import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth, signInWithPopup, signOut } from "firebase/auth";
import { FIREBASE_OPTIONS } from "./secret";

const firebaseConfig = FIREBASE_OPTIONS;

const firebaseApp = initializeApp(firebaseConfig);


const CALENDAR_SCOPES = [
  'https://www.googleapis.com/auth/calendar.events',
];

export const signUpWithGoogle = async (withCalendar = false) => {
    try {
      const googleProvider = new GoogleAuthProvider();
      if (withCalendar) {
        CALENDAR_SCOPES.forEach((scope) => googleProvider.addScope(scope));
      }
      const auth = getAuth(firebaseApp);
      const res = await signInWithPopup(auth, googleProvider);
    //   console.log(res.user.providerData[0]?.uid);
    //   console.log(res.user.accessToken);

      return {
        email: res.user.email,
        google_id: res.user.providerData[0]?.uid,
        access_token: res.user.accessToken,
        name: res.user.displayName,
      }
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const signInWithGoogleCalendar = () => signUpWithGoogle(true);

export const signOutGoogle = async()=>{
    try {
        const auth = getAuth(firebaseApp);
        await signOut(auth);
    } catch (error) {
        console.log(error);
    }
}